export const PERSIST_SECRET_KEY = "mofa-auth-state";

export const PAGE_SIZE = 10;

export const EXPORT_PAGE_SIZE = 500;

export const MAX_SIZE_IN_BYTES = 5 * 1024 * 1024;

export const OTP_LENGTH = 6;

export const encryptionKey = "c4a96b70e821d3f9d2e6f1b8574c03ed";

// export const loginApiUrl = "/api/Login/Token";
export const loginApiUrl = "/api/Login/CaptchaLogin";

export enum VEHICLE_PERMIT {
  PENDING = -1,
  ALLOWED = 1,
}

export const DROPDOWN_YEAR_RANGE = 5;
export const FIRST_MONTH_OF_YEAR = 0; // January
export const LAST_MONTH_OF_YEAR = 11; // December

export const allowedImagesTypes = ["image/png", "image/jpeg", "image/jpg"];
export const allowedFileTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
];


export const ATTACHMENT_KEYS = {
  PHOTO: "photo",
  EID: "eid",
  PASSPORT: "passport",
  VEHICLE: "vehicleRegLicense",
} as const;

export const attachmentKeys = Object.values(ATTACHMENT_KEYS);

export const USER_PROFILE_ATTACHMENT_KEYS = {
  NATIONAL_ID: "nationalId",
  HOST_EMPLOYEE_CARD: "hostEmployeeCard",
}

export const userProfileAttachmentKeys = Object.values(USER_PROFILE_ATTACHMENT_KEYS);

export const WAREHOUSE_IN_OUT_PERMIT_ATTACHMENT_KEYS = {
  ESCORTING_EMPLOYEE_ID_CARD: "escortingEmployeeIdCard",
} as const;

export const warehouseInOutPermitttachmentKeys = Object.values(
  WAREHOUSE_IN_OUT_PERMIT_ATTACHMENT_KEYS,
);

export const PC_IN_OUT_PERMIT_ATTACHMENT_KEYS = {
  EMPLOYEE_ID_CARD: "employeeIdCard",
} as const;

export const pcInOutPermitttachmentKeys = Object.values(
  PC_IN_OUT_PERMIT_ATTACHMENT_KEYS,
);

export const PERMIT_TO_WORK_ATTACHMENT_KEYS = {
  WORK_PLAN: "workPlan",
  METHOD_STATEMENT: "methodStatement",
  RISK_ASSESSMENT: "riskAssessment",
} as const;

export const permitToWorkAttachmentKeys = Object.values(
  PERMIT_TO_WORK_ATTACHMENT_KEYS,
);

export const PARKING_STICKER_REQUEST_ATTACHMENT_KEYS = {
  EMPLOYEE_CARD: "uploadEmployeeCard",
  NATIONAL_ID: "uploadNationalId",
} as const;

export const parkingStickerRequestAttachmentKeys = Object.values(
  PARKING_STICKER_REQUEST_ATTACHMENT_KEYS,
);

export const PARKING_STICKER_REQUEST_ATTACHMENTS_TYPE = {
  EMPLOYEE_CARD: 1,
  NATIONAL_ID: 2,
  VEHICLE_REGISTRATION_LICENSE: 4,
};

export const ISSUANCE_RENEWAL_ID_ATTACHMENT_KEYS = {
  PERSONAL_PHOTO: "uploadPersonalPhoto",
  NATIONAL_ID_COPY: "uploadCopyOfNationalId",
  CONTRACTORS_AUTHORIZATION_LETTER: "uploadContractorsAuthorizationLetter",
} as const;

export const issuanceRenewalIdAttachmentKeys = Object.values(
  ISSUANCE_RENEWAL_ID_ATTACHMENT_KEYS,
);

export const ISSUANCE_RENEWAL_ID_ATTACHMENT_TYPE = {
  PERSONAL_PHOTO: 1,
  NATIONAL_ID_COPY: 2,
  CONTRACTORS_AUTHORIZATION_LETTER: 3,
};

export enum DYNAMIC_WORKFLOW {
  DEVICES_APPROVAL_ONE_DAY_VISIT = "87",
}

export enum BLACKLIST_TYPES {
  COMPANY = 2305,
  // NATIONALITY = 2306,
  PERSON = 2307,
}

export enum DEVICE_STATUSES {
  ONLINE = 2295,
  OFFLINE = 2296,
}

export enum QR_ACTIONS {
  CHECK_IN = "CHECK_IN",
  CHECK_OUT = "CHECK_OUT",
}

export enum VISIT_CREATED_FROM {
  VMS = 1,
  MOBILE_APP = 2,
}

export enum INVALID_PHOTO_ERRORS {
  PHOTO_VALIDATION_FAILED = 0,
  PICTURE_FORMAT_ERROR = 1,
  WRONG_SIZE = 2,
  PICTURE_SIZE_TOO_SMALL = 3,
  RESOLUTION_NO_SUPPORT = 4,
  FACE_QUALITY_NOT_OK = 16,
  NO_PICTURE = 17,
  NO_FACE = 18,
  MULTIPLE_FACES_DETECTED = 19,
  FACE_TOO_SMALL = 20,
  PICTURE_TOO_BRIGHT = 21,
  PICTURE_TOO_DARK = 22,
  FACE_TOO_BLUR = 23,
  WRONG_FACE_POSE = 24,
  DUPLICATE_FACE_IMAGE = 33,
  DUPLICATE_FACE_NUMBER = 34,
  DUPLICATE_FACE_NAME = 36,
}

export enum KIOSK_CHECK_IN_FLOW {
  ONLY_QR_CODE_SCAN = 1,
  ONLY_FACIAL_SCAN = 2,
  BOTH_QR_FACIAL_SCAN = 3,
}

export enum EVACUATION_EVENT_ACTION_TYPES {
  CLOSE = "CLOSE",
  CANCEL = "CANCEL",
}

export enum API_ERRORS {
  CANNOT_CANCEL_OLD_VISIT_REQUESTS = "CannotCancelOldVisitRequest",
  VISIT_ALREADY_CANCELLED = "VisitAlreadyCancelled",
  CANNOT_CHECKIN_OLD_VISIT_REQUEST = "CannotCheckInOldVisitRequest",
  CANNOT_CHECKIN_FUTURE_VISIT_REQUEST = "CannotCheckInFutureVisitRequest",
  CANNOT_CHECKIN_INVALID_VISIT_LOCATION = "CannotCheckInInvalidVisitLocation",

  NATIONALITY_ALREADY_BLACKLISTED = "NationalityAlreadyBlacklisted",
  VISITOR_ALREADY_BLACKLISTED = "VisitorAlreadyBlacklisted",
  COMPANY_ALREADY_BLACKLISTED = "CompanyAlreadyBlacklisted",

  USER_BUILDINGS_REQUIRED = "UserBuildingsRequired",

  CANNOT_CANCEL_OLD_PERMIT_REQUESTS = "CannotCancelOldPermitRequest",
  PERMIT_ALREADY_CANCELLED = "PermitAlreadyCancelled",

  CANNOT_CLOSE_EVACUATION_EVENT_MISSING_PARTICIPANT = "CannotCloseMissingEvacuationFound",

  INVALID_MOBILE_NUMBER = "InvalidMobileNumber",

  MAX_ALLOWED_DAYS_EXCEEDED = "MaxAllowedDaysExceeded"
}

export enum SSO_API_ERRORS {
  SSO_EXCHANGE_FAILED = "SSO_ExchangeFailed",
  SSO_AUTH_FAILED = "SSO_AuthFailed",
  SSO_UNKNOWN = "SSO_Unknown",
}

export type SerilogEntry = {
  "@t": string;
  "@mt": string;
  "@r"?: string[];
  RequestMethod: string;
  RequestPath: string;
  StatusCode: number;
  Elapsed: number;
};

export enum PermitTypes {
  PC_IN_OUT_PERMIT = 2312,
  WAREHOUSE_IN_OUT_PERMIT = 2313,
  PERMIT_TO_WORK = 2354,
  LOST_VEHICLE_STICKER_ID_CARD = 2401,
  PARKING_STICKER_REQUEST = 2402,
  OFFICE_ACCESS_AUTHORIZATION = 2403,
  ISSUANCE_RENEWAL_ID = 2411,
}

export enum PERMIT_TYPES {
  PC_IN_OUT_PERMIT = "PC_IN_OUT_PERMIT",
  WAREHOUSE_IN_OUT_PERMIT = "WAREHOUSE_IN_OUT_PERMIT",
  PERMIT_TO_WORK = "PERMIT_TO_WORK",
  LOST_VEHICLE_STICKER_ID_CARD = "LOST_VEHICLE_STICKER_ID_CARD",
  PARKING_STICKER_REQUEST = "PARKING_STICKER_REQUEST",
  OFFICE_ACCESS_AUTHORIZATION = "OFFICE_ACCESS_AUTHORIZATION",
  ISSUANCE_RENEWAL_ID = "ISSUANCE_RENEWAL_ID",
}

export enum ACCOUNT_LOCKOUT_STATUSES {
  LOCKED = 1,
  OTP_REQUIRED = 2,
}

export interface WorkPermitApprover {
  approverRole: string;
  approverName: string;
  dt_ApprovalDate: string;
  comments: string | null;
  uploadSignature: string;
  uploadSignatureContentType: string;
}

export enum DEVICE_TYPES {
  FR = 1144,
  KIOSK = 1145,
}

export enum EVACUATION_EVENT_PARTICIPANTS_STATUSES {
  CANCELLED = 2327,
  SAFE = 2328,
  EXITED = 2329,
  MISSING = 2330,
}

export enum EVACUATION_METHODS {
  MANUAL = 2331,
  QR = 2332,
  FR_READER = 2333,
  CCTV = 2334,
}

export interface Pagination {
  pageNumber: number;
  pageSize: number;
  count: number;
  pages: number;
}

export enum VISITOR_VISIT_STATUSES {
  VISIT_NOT_STARTED = 2279,
  CHECKED_IN = 2280,
  CHECKED_OUT = 2281,
}

export enum BLACKLIST_STATUS {
  BLACKLISTED = 2310,
  UNBLACKLISTED = 2311,
}

export enum FR_ACCESS_STATUSES {
  AUTHORIZED = 2289,
  UNAUTHORIZED = 2290,
}

export enum FR_IDENTITY_TYPES {
  VISITOR = 2291,
  UNIDENTIFIED = 2292,
}

export enum BADGE_PRINT_STATUSES {
  NOT_PRINTED = 2284,
  PRINTED = 2285,
}

export enum CHECK_IN_OUT_TYPES {
  VMS = 2282,
  KIOSK = 2283,
  VEHICLE = 2293,
}

export enum CHECK_IN_OUT_TYPE_KEYS {
  VEHICLE = "VEHICLE",
}

export enum ACTION_TYPES {
  CHECKED_IN = "CHECKED_IN",
}

export enum EVACUATION_EVENT_STATUSES {
  ACTIVE = "2325",
  CLOSED = "2326",
  CANCELLED = "2327",
}

export enum PERMIT_TO_WORK_CATEGORIES {
  GENERAL_WORKS = "2340",
  HIGH_RISK_WORKS = "2341",
}

export enum SYSTEM_DETAIL_CODES {
  DEVICE_TYPES = "1027",
  VISITOR_DEVICE_TYPES = "1036",
  VISITOR_DEVICE_PURPOSES = "1037",
  COMMENT_TYPES = "1038",
  CHECK_IN_OUT_TYPES = "1040",
  IDENTITIES = "1043",
  BLACKLIST_TYPES = "1045",
  VISIT_DURATION_TYPES = "1046",
  PERMIT_TYPES = "1048",
  WAREHOUSE_IN_OUT_PERMIT_GENERAL_DESCRIPTIONS = "1049",
  MUSTER_EVENT_TYPE = "1050",
  EMERGENCY_EVACUATION_PERSON_TYPE = "1051",
  EMERGENCY_EVACUATION_STATUS = "1052",
  EMERGENCY_EVACUATION_EVENT_PARITICIPANT_STATUSES = "1053",
  PERMIT_AFFECTED_SERVICES = "1055",
  PERMIT_WORK_CATEGORY = "1056",
  PERMIT_HIGH_RISK_WORK_CATEGORY = "1057",
  PERMIT_WORK_TYPE = "1058",
  OFFICE_ACCESS_AUTHORIZATION_REQUESTED_SERVICES = '1059'
}

export enum VISIT_DURATION_TYPES_IDS {
  ALL = 0,
  ONE_DAY = 2300,
  MULTIPLE_DAYS = 2301,
}

export interface SelectInputOption {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}

export enum ContentType {
  PDF = "application/pdf",
}

export enum DELETE_STATUSES {
  USED_IN_APPOINTMENT = 1,
  USED_IN_ACCESS_GROUP_DEVICES = 2,
  USED_IN_DEPARTMENT = 2,
}

export enum VisitorType {
  VVIP = "2191",
}

export enum DEVICES_APPROVE_REQUEST_DETAILS_TABLE {
  APPROVE_DETAILS_TABLE = "APPROVE_DETAILS_TABLE",
  REQUEST_DETAILS_TABLE = "REQUEST_DETAILS_TABLE",
}

export enum PROCESSES {
  ENCRYPT = "ENCRYPT",
  DECRYPT = "DECRYPT",
}

export enum EPingType {
  CMD = 1,
  FRChallenge = 2,
}

export enum EVACUATION_START_UPDATE_TYPE {
  START = "START",
  UPDATE = "UPDATE",
  START_AND_SEND_ALERT = "START_AND_SEND_ALERT",
  UPDATE_AND_SEND_ALERT = "UPDATE_AND_SEND_ALERT",
}

export enum CommentType {
  DEVICES_REQUESTED_INFO = 2266,
  DEVICES_APPROVAL = 2267,
  VISIT_REQUESTED_INFO = 2268,
  VISIT_APPROVAL = 2269,
  VISIT_REJECTION = 2270,
  DEVICES_RESUBMITTED_FROM_VISITOR = 2271,
  DEVICES_RESUBMITTED_FROM_STAFF = 2272,
  VISIT_RESUBMITTED_FROM_VISITOR = 2273,
  VISIT_RESUBMITTED_FROM_STAFF = 2274,
  VISIT_SUBMITTED_FROM_VISITOR = 2275,
  VISIT_SUBMITTED_FROM_STAFF = 2276,
  DEVICES_DELETED = 2277,
  VISIT_CANCELLED_FROM_VISITOR = 2278,
}

export enum TABLE_IDS {
  APPROVE_VISIT_REQUEST = "approve-visit-request-table",
  SEARCH_VISIT_REQUEST = "search-visit-request-table",
  VISIT_REQUEST_REPORT = "visit-request-report-table",
  ACCESS_LOG_REPORT = "access-log-report-table",
  AUDIT_LOGS_REPORT = "audit-logs-report-table",
  EMPLOYEE_REPORT = "employee-report-table",
  EXTERNAL_USERS_REPORT = "external-users-report-table",
  LOGIN_USER_REPORT = "login-user-report-table",
  OVERSTAYED_VISITORS = "overstayed-visitors-table",
  SEARCH_USERS = "search-users-table",
  VISIT_PURPOSE = "visit-purpose-table",
  PENDING_APPROVALS = "pending-approvals-table",
  EXPECTED_VISITORS = "expected-visitors-table",
  VISITORS_REPORT = "visitors-report-table",
  ACCESS_GROUPS = "access-groups-table",
  BUILDINGS_CONFIG = "buildings-config-table",
  COMMENTS = "comments-table",
  DEPARTMENTS = "departments-table",
  DEVICES_CONFIG = "devices-config-table",
  MEETING_ROOMS_CONFIG = "meeting-rooms-config-table",
  CHECKED_IN_VISITORS = "CHECKED_IN_VISITORS",
  CHECKED_OUT_VISITORS = "CHECKED_OUT_VISITORS",
  RATINGS_REPORT = "ratings-report-table",
  BLACKLIST_VISITORS = "blacklist-visitors-table",
  BLACKLISTING_REPORT = "blacklisting-report-table",
  SEARCH_PERMIT_REQUEST = "search-permit-request-table",
  APPROVE_PERMIT_REQUEST = "approve-permit-request-table",
  LIVE_EVACUATION_DASHBOARD = "live-evacuation-dashboard-table",
  MUSTER_POINTS_CONFIG = "muster-points-config-table",
  EVACUATION_EVENTS = "evacuation-events-table",
  MUSTER_STATION = "muster-station-table",
  FR_ERRORS_REPORT = "fr-errors-report-table",
  EVACUATION_REPORT = "evacuation-report-table",
}

export interface MusterPoint {
  n_MusterPointID: number;
  s_MusterPointName_En: string;
  s_MusterPointName_Ar: string;
  n_LocationID: number;
  s_LocationName_En: string;
  s_LocationName_Ar: string;
  s_BuildingIDs: string;
  s_BuildingNames_En: string;
  s_BuildingNames_Ar: string;
  s_MusterPointMapLink: string;
  haveMusterPointMap: number;
  dt_CreatedDate: string;
}

export interface Role {
  s_RoleName: string;
  s_RoleNameAr: string;
  n_RoleID: number;
}

export enum STATUS_INDICATOR_COLUMN {
  CURRENT_ROLE_STATUS = "currentRoleStatus",
  ADMIN_STATUS = "adminStatus",
  SELECT = "select",
}

export interface AuditLog {
  fullName: string;
  s_Actions: string;
  dT_AuditDatetime: string;
  s_LocationName_En: string;
  s_LocationName_Ar: string;
  s_BuildingName_En: string;
  s_BuildingName_Ar: string;
  logType: string;
}

export enum PAGE_NAME {
  APPROVE_APPOINTMENT_BY_STAFF = "ApproveAppointmentByStaff",
  SEARCH_APPOINTMENT_BY_STAFF = "SearchAppointmentByStaff",
}

export enum EXPORT_TYPES {
  EXCEL = "EXCEL",
  PDF = "PDF",
}

export enum REPORT_NAMES {
  VISIT_REQUEST_REPORT = "VisitRequestReport",
  ACCESS_LOG_REPORT = "AccessLogReport",
  VISITORS_REPORT = "VisitorsReport",
  EXTERNAL_USERS_REPORT = "ExternalUsersReport",
  LOGIN_USER_REPORT = "LoginUserReport",
  AUDIT_LOGS_REPORT = "AuditLogsReport",
  OVERSTAYED_VISITORS = "OverStayedVisitorsReport",
  FR_ERRORS_REPORT = "FrErrorsReport",
  RATINGS_REPORT = "RatingsReport",
  SEARCH_VISIT_REQUESTS = "SearchVisitRequests",
  APPROVED_VISIT_REQUESTS = "ApprovedVisitRequests",
  ALL_USERS = "AllUsers",
}

export enum EMAIL_TEMPLATE_CODES {
  VISIT_SUBMITTED = "1198",
  VISIT_REQUEST_SCHEDULE_TEMPLATE = "1199",
  VISIT_APPROVED_HOST_EMAIL = "1200",
  VISIT_REJECTED_HOST_EMAIL = "1201",
  EMAIL_TO_HOST_TEMPLATE = "1202",
  VISIT_REQUEST_REJECTED_TEMPLATE = "1203",
  EXTERNAL_PASSWORD_RESET = "1204",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_HOST = "1205",
  EXTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR = "1206",
  EXTERNAL_ACCOUNT_REGISTRATION = "1207",
  VISIT_REQUESTED_INFO_TO_VISITOR = "1209",
  VISIT_REQUESTED_INFO_TO_STAFF = "1210",
  VISITOR_CHECK_IN = "6",
  VISITOR_CHECK_OUT = "7",
  OTP_TEMPLATE = "1225",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_VISITOR = "1231",
  INTERNAL_CANCEL_VISIT_REQUEST_TO_HOST = "1233",
  EMERGENCY_EVACUATION = "1244",
  FINAL_PERMIT_APPROVAL_RECIPIENTS = "1247"
}

export interface PieChartData {
  name: string;
  value: number;
}

export interface Attachments {
  havePhoto: number;
  haveIqama: number;
  haveEid: number;
  havePassport: number;
  haveOthers: number;
  haveVisa: number;
  haveVehicleRegistration: number;
  haveHostEmployeeCard: number;
}

export interface WarehouseWorkersAttachments {
  haveId: number;
}

export enum ATTACHMENTS_TYPE {
  PHOTO = 1,
  EID = 2,
  PASSPORT = 3,
  VEHICLE = 4,
  IQAMA = 5,
  OTHERS = 6,
  VISA = 7,
  HOST_EMPLOYEE_CARD = 8,
}

export enum USER_PROFILE_ATTACHMENTS_TYPE {
  NATIONAL_ID = 1,
  HOST_EMPLOYEE_CARD = 2,
}

export enum PC_IN_OUT_PERMIT_ATTACHMENTS_TYPE {
  EMPLOYEE_ID_CARD = 1,
}

export enum PERMIT_TO_WORK_ATTACHMENTS_TYPE {
  WORK_PLAN = 1,
  METHOD_STATEMENT = 2,
  RISK_ASSESSMENT = 3,
}

export enum WAREHOUSE_IN_OUT_PERMIT_ATTACHMENTS_TYPE {
  ESCORTING_EMPLOYEE_ID_CARD = 1,
  PERSONNEL_ID = 2,
  VEHICLE_REGISTRATION_LICENSE = 3,
}

export enum STATUS_IDS {
  APPROVED = 49,
  PENDING = 50,
  REJECTED = 51,
  CANCELED = 1142,
  EXPIRED = 2186,
  REQUEST_INFO = 2265,
  SELECT = 0,
  SELECTED = 1,
  UN_SELECTED = -1,
}

export enum USER_ROLES_IDS {
  ADMIN = 1,
  STAFF = 4,
  RECEPTION = 5,
  SECURITY = 6,
  SECURITY_MANAGER = 11,
  CYBER_SECURITY = 12,
  AUTHORIZED_PERSON = 13,
  DIRECT_MANAGER = 15,
  INVENTORY_MANAGER = 16,
}

export enum USER_ROLES {
  ADMIN = "ADMIN",
  STAFF = "STAFF",
  RECEPTION = "RECEPTION",
  SECURITY = "SECURITY",
  SECURITY_MANAGER = "SECURITY_MANAGER",
  CYBER_SECURITY = "CYBER_SECURITY",
  AUTHORIZED_PERSON = "AUTHORIZED_PERSON",
}

export enum VISIT_REQUEST_VIEW_TYPE {
  VIEW_ONLY = "view_only",
}

export const PHOTO_NOTES = [
  "photoColouredTakenWithinLastSixMonths",
  "PNGJPGJPEGPhotosAcceptable",
  "photoBackgroundClear",
  "photoSizeBelow5MB",
  "photoResolutionRangeminimumFace",
];

export const WAREHOUSE_IN_OUT_PERMIT_VALIDITY_NOTES = [
  "validityOfPermit1DayQuantityLessThan50",
  "validityOfPermit3DaysQuantity50OrMore",
];

enum USER_TYPES {
  EMPLOYEES = 1,
  VISITORS = 2,
  CONTRACTORS = 3,
}

export interface SupportingDocument {
  key: string;
  label: string;
  checked?: boolean;
  mandatory?: boolean;
}

export const pcInOutPermitSupportingDocuments: SupportingDocument[] = [
  { key: "haveUserCardFile", label: "Employee ID Card", checked: false, mandatory: true },
]

export const issuanceRenewalIdSupportingDocuments: SupportingDocument[] = [
  { key: "havePersonalPhotographFile", label: "Personal Photo", checked: false, mandatory: true },
  { key: "haveNationalIDCopyFile", label: "Copy of National ID", checked: false, mandatory: true },
  { key: "haveAuthorizationLetterFile", label: "Contractor's Authorization Letter", checked: false, mandatory: true },
]

export const parkingStickerRequestSupportingDocuments: SupportingDocument[] = [
  { key: "haveHostNationalID", label: "National ID", checked: false, mandatory: true },
  { key: "haveHostEmployeeCard", label: "Employee Card", checked: false, mandatory: true },
]

export const warehouseInOutPermitSupportingDocuments: SupportingDocument[] = [
  { key: "haveUserCard", label: "Escorting Employee ID Card", checked: false, mandatory: true },
]

export const permitToWorkSupportingDocuments: SupportingDocument[] = [
  { key: "haveWorkPlanFile", label: "Work Plan", checked: false, mandatory: true },
  { key: "haveMethodStatementFile", label: "Method Statement", checked: false, mandatory: true },
  { key: "haveRiskAssessmentFile", label: "Risk Assessment", checked: false, mandatory: true },
]

export const userTypes = [
  {
    id: 7,
    labelEn: "Employees",
    labelAr: "الموظفين",
    value: USER_TYPES.EMPLOYEES,
  },
  { id: 8, labelEn: "Visitors", labelAr: "الزوار", value: USER_TYPES.VISITORS },
  {
    id: 9,
    labelEn: "Contractors",
    labelAr: "المقاولين",
    value: USER_TYPES.CONTRACTORS,
  },
];

export interface Comment {
  n_CommentType: number;
  s_Comment: string;
  n_RoleID: number;
  s_CommentDate: string;
  s_RoleName_En: string | null;
  s_RoleName_Ar: string | null;
  s_CommentType_En: string;
  s_CommentType_Ar: string;
}

export const addBlacklistVisitorInitialValues = {
  blacklistType: 0,
  eid: "",
  passportNumber: "",
  companyName: "",
};

export interface AddAttachments {
  Id: number;
  File?: File | string | null;
  S_FileFieldName: string;
  S_FileType?: string;
  S_FiledFileType: string;
}

export interface Device {
  id: string;
  deviceType: number;
  deviceTypeOther: string;
  deviceModel: string;
  serialNumber: string;
  devicePurpose: number;
  purpose: string;
  devicePurposeOther: string;
  deviceTypeOthersValue: string;
  devicePurposeOthersValue: string;
  appointmentDeviceId: number;
  approvalStatus: STATUS_IDS;
  currentUserDeviceStatus: STATUS_IDS;
  selected?: boolean;
  comment?: string;
  status?: STATUS_IDS;
}

export interface Vehicle {
  id: string;
  plateSource?: string;
  plateTypeEn?: string;
  plateTypeAr?: string;
  plateCode?: string;
  plateNumber?: string;
  plateCountry?: string;
  plateLetter1?: string;
  plateLetter2?: string;
  plateLetter3?: string;
  uploadVehicleRegLicense?: any;
  driversId?: string;
  driversName?: string;
  color?: string;
  personnelId?: number;
  driverTempClientID?: string;
}

export interface ParkingStickerVehicle {
  id: string;
  plateSource?: string;
  plateTypeEn?: string;
  plateTypeAr?: string;
  plateCode?: string;
  plateNumber: string;
  plateCountry?: string;
  plateLetter1?: string;
  plateLetter2?: string;
  plateLetter3?: string;
  color?: string;
  model?: string;
  stickerParkingNumber?: string;
  copyNumber?: string;
  uploadVehicleRegLicense?: any;
}

export interface UserAppointment {
  id: number;
  name: string;
  companyName: string;
  nationality: string;
  number: string;
  email: string;
  dateOfBirth?: string | null;
  nextDevicesApproverRoleId: number;
  devicesApprovalStatus: STATUS_IDS;

  idType: number;
  iqama?: string;
  iqamaExpiryDate?: string | null;
  eid: string;
  eidExpiryDate?: string | null;
  passportNumber: string;
  passportExpiryDate?: string | null;
  idTypeOtherName?: string;
  idTypeOtherNumber?: string;
  idTypeOtherExpiryDate?: string | null;

  visaNumber?: string;
  visaExpiryDate?: string | null;

  plateSource?: string;
  plateCode?: string;
  plateNumber?: string;

  plateLetter1?: string;
  plateLetter2?: string;
  plateLetter3?: string;

  location: number;
  building?: number;
  meetingRoom?: number;
  visitReqType: number;
  visitPurpose: number;
  visitPurposeOther?: string;
  hostEmail: string;
  visitStartDate: string;
  visitEndDate: string;
  vehicleNo: string;
  reqAccessLevels?: string;
  accessLevels?: string;

  note?: string;

  uploadPhoto?: string;
  uploadEid?: string;
  uploadPassport?: string;
  uploadVehicleRegLicense?: string;

  uploadPhotoType?: string;
  uploadEidType?: string;
  uploadPassportType?: string;

  photoFileType?: string;
  eidFileType?: string;
  passportFileType?: string;
  vehicleRegLicenseFileType?: string;
  uploadVehicleRegLicenseType?: string;

  isExternalAppointment?: boolean;
  isVehicleAllowed?: boolean;

  approvalStatus: STATUS_IDS;

  currentApproverOrderNo?: number;
}

export interface DescriptionOfWarehouseItem {
  id: string;
  itemType: string;
  quantity: number;
  supplyingExportingEntityForPermitHolder: string;
}

export interface WarehousePermitWorker {
  id: string;
  name: string;
  nationality: string;
  residencePermitNo: string;
  issuingAuthority: string;
  issueDate: string;
  uploadId?: any;
}

export interface Visitor {
  id: string;
  FullName: string;
  Sponsor: string;
  Email: string;
  MobileNo: string;
  IDType: number;
  EIDNumber: string;
  Dt_EIDExpiryDate: string;
  PassportNumber: string;
  Dt_PassportExpiryDate: string;
  Nationality: string;
  S_Iqama: string;
  Dt_IqamaExpiry: string;
  Dt_OthersExpiry: string;
  S_OthersValue: string;
  idType?: number;
  S_VisaNo?: string;
  Dt_VisaExpiryDate: string;
  Dt_DateOfBirth?: string | null;

  uploadPhoto?: string;
  photoFileType?: string;

  uploadEid: string;
  eidFileType?: string;

  uploadPassport?: string;
  passportFileType: string;

  uploadVehicleRegLicense?: string;
  vehicleRegLicenseFileType?: string;

  uploadIqama?: any;
  iqamaFileType?: any;

  uploadHostEmployeeCard?: any;
  hostEmployeeCardFileType?: any;

  uploadIdOther?: any;
  S_OthersDoc: string;
  idOtherFileType?: any;

  uploadVisa?: any;
  visaFileType?: any;

  isDuplicate?: boolean;

  S_VehicleNo?: string;
  dateOfBirth?: string | null;

  Devices?: any;
}

export enum Statuses {
  APPROVED = "Approved",
  PENDING = "Pending",
  REJECTED = "Rejected",
  CANCELLED = "Cancelled",
  EXPIRED = "Expired",
  REQUEST_INFO = "Request Info",
}

export enum PendingStatuses {
  PENDING_STAFF = "Pending - Staff",
  PENDING_AUTHORIZED_PERSON = "Pending - Authorized Person",
  PENDING_CYBER_SECURITY = "Pending - Cyber Security",
  PENDING_SECURITY = "Pending - Security User",
  PENDING_SECURITY_MANAGER = "Pending - Security Manager",
  PENDING_DIRECT_MANAGER = "Pending - Direct Manager",
  PENDING_INVENTORY_MANAGER = "Pending - Inventory Manager",
}

export interface Process {
  n_ProcessID: number;
  s_ProcessName: string;
  s_ProcessName_Ar: string;
}

export interface VisitorDetails {
  s_AppointmentCode: string;
  id: string;
  n_AppointmentID: string;
  s_VisitorName: string;
  s_VisitorName_En: string;
  s_Sponsor: string;
  dt_AppointmentStartTime: string;
  dt_AppointmentEndTime: string;
  s_MobileNo: string;
  s_LocationName_En: string;
  s_LocationName_Ar: string;
  s_BuildingName_En: string;
  s_BuildingName_Ar: string;
  s_GateName_En: string;
  s_GateName_Ar: string;
  s_Email: string;
  s_Purpose: string;
  s_HostName: string;
  s_ApprovalStatusEn: string;
  dt_CreatedDate_External: string;
  s_ApplyFor_En: string;
  s_ApplyFor_Ar: string;
  dt_DateOfBirth: string;
  s_HostEmail: string;
  s_Nationality_En: string;
  s_Nationality_Ar: string;
  s_DocumentType_En: string;
  s_DocumentType_Ar: string;
  s_Iqama: string;
  dt_IqamaExpiry: string;
  eidNumber: string;
  dt_EIDExpiryDate: string;
  passportNumber: string;
  dt_PassportExpiryDate: string | null;
  s_VisaNo: string;
  dt_VisaExpiryDate: string | null;
  s_MeetingRoomName_En: string;
  s_MeetingRoomName_Ar: string;
  s_DepartmentName_En: string;
  s_DepartmentName_Ar: string;
  s_VisitType_En: string;
  s_VisitType_Ar: string;
  s_PurposeEn: string;
  s_PurposeAr: string;
  s_IsVehicleAllowed_En: string;
  s_IsVehicleAllowed_Ar: string;
  s_ApprovalStatus_En: string;
  s_ApprovalStatus_AR: string;
  s_CreatedBy: string;
  dt_CreatedDate: string;
  currentRoleAppointmentStatusEN: string;
  currentRoleAppointmentStatusAR: string;
  overAllAppointmentStatusEN?: string;
  overAllAppointmentStatusAR?: string;
  s_Duration_En?: string;
  s_Duration_Ar?: string;
  s_VehicleNo: string;
  n_IsVehicleAllowed: number;
  n_CheckedInStatus: number;
  s_CheckedInStatus_En: string;
  s_CheckedInStatus_Ar: string;
  dt_CheckInDateTime: string;
  dt_CheckOutDateTime: string;
  s_Reason: string;
  s_CheckedInBy: string;
  s_CheckedOutBy: string;
  s_LateCheckedInReason: string;
  s_LateCheckedOutReason: string;
  n_BadgePrintStatus: BADGE_PRINT_STATUSES;
  s_BadgePrintStatus_En: string;
  s_BadgePrintStatus_Ar: string;
  s_CheckedInType_En: string;
  s_CheckedInType_Ar: string;
  s_CheckedOutType_En: string;
  s_CheckedOutType_Ar: string;
  s_CheckInGateName_En: string;
  s_CheckInGateName_Ar: string;
  s_CheckOutGateName_En: string;
  s_CheckOutGateName_Ar: string;
  approvalStatus: number;
  n_IsProcessed: number;
  dt_ProcessedTime: string;
  dt_DeleteProcessedTime: string;
  dt_ErrorRetryTime: string;
  n_IsDeleteProcessed: number;
  n_IsErrorOccur: number;
  n_ErrorRetryCount: number;
  s_AccessGroupName_En: string;
  s_AccessGroupName_Ar: string;
  checkinID: number;
}

export interface WarehouseInOutPermitRequestDetails {
  id: number;
}

export interface PCInOutPermitRequestDetails {
  id: number;
  deviceType: string;
  serialNumber: string;
  permitStartDate: string;
  permitEndDate: string;
  building: string;
  employeeName: string;
}

export interface PermitToWorkDetails {
  id: number;
}

export interface PermitDetails {
  n_PermitID: number;
  s_PermitCode: string;
  n_PermitTypeID: PermitTypes;
  n_UserID: number;
  s_LaptopType: string;
  s_LaptopSerialNumber: string;
  dt_PermitStartDate: string;
  dt_PermitEndDate: string;
  n_ApprovalStatus: number;
  s_ApprovalStatus_En: string;
  s_ApprovalStatus_AR: string;
  currentRolePermitStatusEN: string;
  currentRolePermitStatusAR: string;
  overAllPermitStatusEN: string;
  overAllPermitStatusAR: string;
}

export interface SystemCodesDetails {
  n_DetailedCode: number;
  s_Desc_E: string;
  s_Desc_A: string;
  n_MasterCode: number;
  n_IsDefault: number;
}

export interface VisitPurposeDetails {
  n_PurposeID: number;
  s_PurposeEn: string;
  s_PurposeAr: string;
  n_LocationID: number;
  s_VisitRequestTypeEn: string;
  s_VisitRequestTypeAr: string;
}

export interface UserDetails {
  user_id: number;
  fullname: string;
  username: string;
  email: string;
  mobile: string;
  s_LocationName_En: string;
  s_LocationName_Ar: string;
  s_BuildingName_En: string;
  s_BuildingName_Ar: string;
  s_DepartmentName_En: string;
  s_DepartmentName_Ar: string;
  s_GateName_En: string;
  s_GateName_Ar: string;
  roleName_En: string;
  roleName_Ar: string;
  s_CreatedBy: string;
  dt_CreatedDate: string;
  s_UpdatedBy: string;
  n_IsActive: boolean;
  n_IsADUser: boolean;
}

export enum PasswordField {
  CURRENT = "CURRENT",
  NEW = "NEW",
  CONFIRM = "CONFIRM",
}

export interface Visitor {
  id: string;
  FullName: string;
  Sponsor: string;
  Email: string;
  MobileNo: string;
  IDType: number;
  EIDNumber: string;
  Dt_EIDExpiryDate: string;
  PassportNumber: string;
  Dt_PassportExpiryDate: string;
  Nationality: string;
}

export interface BlacklistedVisitor {
  n_ID: number;
  n_BlacklistType: number;
  blacklistType_EN: string;
  blacklistType_AR: string;
  idType: number;
  s_EmiratesID: string;
  s_PassportNumber: string;
  s_Iqama: string;
  s_VisaNo: string;
  s_CompanyName: string;
  s_Reason: string;
  nationality_EN: string;
  nationality_AR: string;
  blacklistedAt: string;
}

export interface BlacklistingReport {
  idType: number;
  s_EmiratesID: string;
  s_PassportNumber: string;
  s_Iqama: string;
  s_VisaNo: string;
  s_Reason: string;
  dt_ActionDateTime: string;
  n_BlackListedStatus: number;
  s_BlackListedStatus_En: string;
  s_BlackListedStatus_Ar: string;
  s_ActionBy: string;
}

export enum DOC_TYPE_ID {
  NATIONAL_ID = 24,
  PASSPORT = 26,
  IQAMA = 2244,
  OTHER = 2245,
  VISA = 2294,
}

export enum DEVICE_TYPE_ID {
  LAPTOP = 2246,
  PHONE = 2247,
  TABLET = 2248,
  USB_DRIVE = 2249,
}

export enum DEVICE_PURPOSE_ID {
  PRESENTATION = 2251,
  DATA_COLLECTION = 2252,
  GENERAL_USE = 2253,
}

export interface ThreeStatesToggle {
  id: number;
  title: string;
  value: STATUS_IDS;
}

export const passwordValidationInitialState = {
  length: false,
  uppercase: false,
  lowercase: false,
  number: false,
  specialChar: false,
};

export const tableColumnsEn: Record<string, string> = {
  s_AppointmentCode: "Reference Number",
  s_VisitorName_En: "Name",
  s_Sponsor: "Organization Name",
  dt_AppointmentStartTime: "Visit Start Date",
  dt_AppointmentEndTime: "Visit End Date",
  staffApprovalStatusEn: "Staff Approval Status",
  securityApprovalStatusEn: "Security Approval Status",
  s_ApprovalStatusEn: "Approval Status",
  s_Email: "Email",
  s_HostName: "Host Name",
  s_LocationName_En: "Location",
  fullname: "Full Name",
  username: "Username",
  email: "Email",
  mobile: "Mobile Number",
  s_DepartmentName_En: "Department Name",
  roleName_En: "Role Name",
  Action: "Action",
  s_VisitorName: "Name",
  securityApprovalStatusEN: "Security Approval Status",
  overallApprovalStatusEN: "Approval Status",
  s_MobileNo: "Mobile Number",
  s_Duration_En: "Stay Duration",
  s_FullName: "Full Name",
  s_CompanyName: "Organization Name",
  s_MobileNumber: "Mobile Number",
  s_UserName: "Username",
  dt_CreatedDate: "Created Date",
  overAllAppointmentStatusEN: "Final Status",
  logType: "Log Type",
  dT_AuditDatetime: "Log Time",
  s_Actions: "Action",
  fullName: "Full Name",
  s_Purpose: "Visit Purpose",
  createdBy: "Created By",
  createdDate: "Created Date",
  updatedBy: "Updated By",
  n_IsActive: "Status",
  n_IsADUser: "Is AD User",
  n_IsVehicleAllowed: "Vehicle Permit",
  n_CommentType: "Comment Type",
  s_Comment: "Comment",
  n_RoleID: "Comment By",
  s_CommentDate: "Comment Date",
  n_AccessGroupID: "Access Group ID",
  s_AccessGroupName_En: "Access Group Name (English)",
  s_AccessGroupName_Ar: "Access Group Name (Arabic)",
  n_LocationID: "Location",
  n_DeviceID: "Device ID",
  s_DeviceName_En: "Device Name (English)",
  s_DeviceName_Ar: "Device Name (Arabic)",
  s_FRDeviceType_En: "Device Type",
  s_IPAddress: "IP Address",
  s_DeviceLocation: "Device Location",
  s_Direction: "Direction",
  S_KioskFRDeviceName_En: "FR Device",
  s_Description: "Description",
  n_IsAreaDefaultGroup: "Location Default Group",
  s_IsAreaDefaultGroup_En: "Location Default Group",
  s_FRDevicesNames_En: "Devices",
  action: "Action",
  s_CheckedInStatus_En: "Status",
  dt_CheckInDateTime: "Check In Date",
  dt_CheckOutDateTime: "Check Out Date",
  s_CheckedInBy: "Checked In By",
  s_CheckedOutBy: "Checked Out By",
  s_LateCheckedInReason: "Late Check In Reason",
  s_LateCheckedOutReason: "Late Check Out Reason",
  n_BadgePrintStatus: "Print Status",
  n_LogID: "Log ID",
  s_Name: "Full Name",
  s_Identity: "Identity",
  dt_AccessTime: "Access Time",
  s_Device: "Device",
  n_AccessStatus: "Status",
  s_Photo: "Photo",
  s_ErrorDetails: "Error Details",
  currentRoleAppointmentStatusEN: "Current Status",
  IDTypeName_En: "ID Type",
  idNumber: "ID Number",
  n_Rating: "Rating",
  dt_RatingDate: "Rating Date",
  s_CheckedInType_En: "Check In Type",
  s_CheckInGateName_En: "Check In Gate",
  s_CheckedOutType_En: "Check Out Type",
  s_CheckOutGateName_En: "Check Out Gate",
  n_IsProcessed: "Is Processed",
  dt_ProcessedTime: "Processed Time",
  n_IsDeleteProcessed: "Is Delete Processed",
  dt_DeleteProcessedTime: "Delete Processed Time",
  n_IsErrorOccur: "Is Error Occur",
  n_ErrorRetryCount: "Error Retry Count",
  dt_ErrorRetryTime: "Error Retry Time",
  s_BuildingName_En: "Building",
  s_GateName_En: "Gate",
  s_ApplyFor_En: "Apply For",
  dt_DateOfBirth: "Date of Birth",
  s_Nationality_En: "Nationality",
  s_HostEmail: "Host Email",
  s_MeetingRoomName_En: "Meeting Room",
  s_VisitType_En: "Visit Type",
  s_PurposeEn: "Visit Purpose",
  s_DocumentType_En: "Document Type",
  s_Iqama: "Iqama",
  dt_IqamaExpiry: "Iqama Expiry Date",
  eidNumber: "National ID",
  dt_EIDExpiryDate: "National ID Expiry Date",
  passportNumber: "Passport Number",
  dt_PassportExpiryDate: "Passport Expiry Date",
  s_VisaNo: "Visa Number",
  dt_VisaExpiryDate: "Visa Expiry Date",
  s_IsVehicleAllowed_En: "Vehicle Permit",
  s_CreatedBy: "Created By",
  s_VehicleNo: "Vehicle No",
  s_Status_En: "Status",
  blacklistType_EN: "Blacklist Type",
  idType: "ID Type",
  s_EmiratesID: "Emirates ID",
  "s_EmiratesID, s_PassportNumber, s_VisaNo, s_Iqama": "ID Number",
  nationality_EN: "Nationality",
  blacklistedBy: "Blacklisted By",
  blacklistedAt: "Blacklisted At",
  s_Reason: "Reason",
  s_ActionBy: "Action By",
  dt_ActionDateTime: "Action Date",
  s_BlackListedStatus_En: "Status",
  s_PassportNumber: "Passport Number",
  s_PermitCode: "Ref. No.",
  dt_PermitStartDate: "Permit Start Date",
  dt_PermitEndDate: "Permit End Date",
  currentRolePermitStatusEN: "Current Status",
  overAllPermitStatusEN: "Final Status",
  n_EvacuationID: "Event ID",
  s_FloorNo: "Floor",
  s_MusterPointNames_En: "Muster Points",
  eventType: "Event Type",
  s_EventPersonType_En: "Participant Type",
  dt_EventStartTime: "Start Time",
  dt_EventEndTime: "End Time",
  s_EvacuationStatus_En: "Status",
  s_MusterPointName_En: "Muster Point",
  s_ExpectedLocation_En: "Last Seen",
  n_EvacuationMethod: "Method",

  n_EvacuationEventID: "Evacuation ID",
  s_EvacuationCode: "Evacuation Code",
  s_PersonType_En: "User Type",
  s_ActionByName: "Action By",

  s_EventType_En: "Event Type",
  s_Remarks: "Remarks",

  type: "Type",
};

export const tableColumnsAr: Record<string, string> = {
  s_AppointmentCode: "رقم المرجع",
  s_VisitorName_En: "الاسم",
  s_Sponsor: "الجهة التابع لها",
  dt_AppointmentStartTime: "تاريخ بدء الزيارة",
  dt_AppointmentEndTime: "تاريخ انتهاء الزيارة",
  staffApprovalStatusEn: "حالة موافقة الموظفين",
  securityApprovalStatusEn: "حالة موافقة الأمن",
  s_ApprovalStatusEn: "حالة الموافقة",
  s_Email: "البريد الإلكتروني",
  s_HostName: "اسم المضيف",
  s_LocationName_En: "الموقع",
  fullname: "الاسم الكامل",
  username: "اسم المستخدم",
  email: "البريد الإلكتروني",
  mobile: "رقم الهاتف",
  s_DepartmentName_En: "اسم القسم",
  roleName_En: "اسم الدور",
  Action: "الإجراء",
  s_VisitorName: "الاسم",
  securityApprovalStatusEN: "حالة موافقة الأمن",
  overallApprovalStatusEN: "حالة الموافقة",
  s_MobileNo: "رقم الهاتف",
  s_Duration_En: "مدة الإقامة",
  s_FullName: "الاسم الكامل",
  s_CompanyName: "الجهة التابع لها",
  s_MobileNumber: "رقم الجوال",
  s_UserName: "اسم المستخدم",
  dt_CreatedDate: "تاريخ التسجيل",
  overAllAppointmentStatusEN: "الوضع النهائي",
  logType: "نوع السجل",
  dT_AuditDatetime: "وقت السجل",
  s_Actions: "الإجراء",
  fullName: "الاسم الكامل",
  s_Purpose: "غرض الزيارة",
  createdBy: "تم الإنشاء بواسطة",
  createdDate: "تاريخ الإنشاء",
  updatedBy: "تم التحديث بواسطة",
  n_IsActive: "حالة",
  n_IsADUser: "هو مستخدم الدليل النشط",
  n_IsVehicleAllowed: "تصريح مركبة",
  n_CommentType: "نوع التعليق",
  s_Comment: "تعليق",
  n_RoleID: "تعليق بواسطة",
  s_CommentDate: "تاريخ التعليق",
  n_AccessGroupID: "الوصول إلى معرف المجموعة",
  s_AccessGroupName_En: "اسم مجموعة الوصول (الإنجليزية)",
  s_AccessGroupName_Ar: "اسم مجموعة الوصول (العربية)",
  n_LocationID: "الموقع",
  n_DeviceID: "معرف الجهاز",
  s_DeviceName_En: "اسم الجهاز (باللغة الإنجليزية)",
  s_DeviceName_Ar: "اسم الجهاز (عربي)",
  s_FRDeviceType_En: "نوع الجهاز",
  s_IPAddress: "عنوان IP",
  s_DeviceLocation: "موقع الجهاز",
  s_Direction: "اتجاه",
  S_KioskFRDeviceName_En: "جهاز التعرف على الوجه",
  s_Description: "وصف",
  n_IsAreaDefaultGroup: "مجموعة الموقع الافتراضية",
  s_IsAreaDefaultGroup_En: "مجموعة الموقع الافتراضية",
  s_FRDevicesNames_En: "الأجهزة",
  action: "فعل",
  s_CheckedInStatus_En: "حالة",
  dt_CheckInDateTime: "تاريخ الدخول",
  dt_CheckOutDateTime: "تاريخ الخروج",
  s_CheckedInBy: "تم تسجيل الدخول بواسطة",
  s_CheckedOutBy: "تم السحب بواسطة",
  s_LateCheckedInReason: "سبب تسجيل الوصول المتأخر",
  s_LateCheckedOutReason: "سبب تسجيل المغادرة المتأخر",
  n_BadgePrintStatus: "حالة الطباعة",
  n_LogID: "معرف السجل",
  s_Name: "الاسم الكامل",
  s_Identity: "هوية",
  dt_AccessTime: "وقت الوصول",
  s_Device: "جهاز",
  n_AccessStatus: "حالة",
  s_Photo: "صورة",
  s_ErrorDetails: "تفاصيل الخطأ",
  currentRoleAppointmentStatusEN: "الوضع الحالي",
  IDTypeName_En: "نوع الهوية",
  idNumber: "رقم الهوية",
  n_Rating: "تصنيف",
  dt_RatingDate: "تاريخ التقييم",
  s_CheckedInType_En: "نوع تسجيل الدخول",
  s_CheckInGateName_En: "بوابة تسجيل الوصول",
  s_CheckedOutType_En: "نوع الخروج",
  s_CheckOutGateName_En: "بوابة الخروج",
  n_IsProcessed: "تمت معالجته",
  dt_ProcessedTime: "وقت المعالجة",
  n_IsDeleteProcessed: "تمت معالجة الحذف",
  dt_DeleteProcessedTime: "وقت معالجة الحذف",
  n_IsErrorOccur: "حدث خطأ",
  n_ErrorRetryCount: "عدد محاولات إعادة الخطأ",
  dt_ErrorRetryTime: "وقت إعادة محاولة الخطأ",
  s_BuildingName_En: "مبنى",
  s_GateName_En: "بوابة",
  s_ApplyFor_En: "قدم طلب ل",
  dt_DateOfBirth: "تاريخ الميلاد",
  s_Nationality_En: "الجنسية",
  s_HostEmail: "البريد الإلكتروني للمضيف",
  s_MeetingRoomName_En: "غرفة الاجتماعات",
  s_VisitType_En: "نوع الزيارة",
  s_PurposeEn: "الغرض من الزيارة",
  s_DocumentType_En: "نوع الوثيقة",
  s_Iqama: "إقامة",
  dt_IqamaExpiry: "تاريخ انتهاء الإقامة",
  eidNumber: "رقم الهوية الوطنية",
  dt_EIDExpiryDate: "تاريخ انتهاء صلاحية بطاقة الهوية الوطنية",
  passportNumber: "رقم جواز السفر",
  dt_PassportExpiryDate: "تاريخ انتهاء صلاحية جواز السفر",
  s_VisaNo: "رقم التأشيرة",
  dt_VisaExpiryDate: "تاريخ انتهاء التأشيرة",
  s_IsVehicleAllowed_En: "تصريح مركبة",
  s_CreatedBy: "انشا من قبل",
  s_VehicleNo: "رقم اللوحة",
  s_Status_En: "حالة",
  blacklistType_EN: "نوع القائمة السوداء",
  idType: "نوع الهوية",
  s_EmiratesID: "الهوية الإماراتية",
  "s_EmiratesID, s_PassportNumber, s_VisaNo, s_Iqama": "رقم الهوية",
  nationality_EN: "جنسية",
  blacklistedBy: "القائمة السوداء بواسطة",
  blacklistedAt: "المدرجة في القائمة السوداء في",
  s_Reason: "سبب",
  s_ActionBy: "الإجراء بواسطة",
  dt_ActionDateTime: "تاريخ الإجراء",
  s_BlackListedStatus_En: "حالة",
  s_PassportNumber: "رقم جواز السفر",
  s_PermitCode: "الرقم المرجعي",
  dt_PermitStartDate: "السماح بتاريخ البدء",
  dt_PermitEndDate: "تاريخ انتهاء السماح",
  currentRolePermitStatusEN: "الوضع الحالي",
  overAllPermitStatusEN: "الوضع النهائي",
  n_EvacuationID: "معرّف الحدث",
  s_FloorNo: "الطابق",
  s_MusterPointNames_En: "نقاط التجمع",
  eventType: "نوع الحدث",
  s_EventPersonType_En: "نوع المشارك",
  dt_EventStartTime: "وقت البدء",
  dt_EventEndTime: "وقت الانتهاء",
  s_EvacuationStatus_En: "الحالة",
  s_MusterPointName_En: "نقطة التجمع",
  s_ExpectedLocation_En: "آخر ظهور",
  n_EvacuationMethod: "الطريقة",

  n_EvacuationEventID: "معرّف الإخلاء",
  s_EvacuationCode: "رمز الإخلاء",
  s_PersonType_En: "نوع المستخدم",
  s_ActionByName: "العمل بواسطة",

  s_EventType_En: "نوع الحدث",
  s_Remarks: "ملاحظات",

  type: "النوع",
};

export const pageSizeOptions = [
  { labelEn: "5", labelAr: "٥", value: 5 },
  { labelEn: "10", labelAr: "١٠", value: 10 },
  { labelEn: "20", labelAr: "٢٠", value: 20 },
  { labelEn: "50", labelAr: "٥٠", value: 50 },
  { labelEn: "100", labelAr: "١٠٠", value: 100 },
];

export interface IndividualData {
  name: string;
  companyName?: string;
  nationality?: string;
  number?: string;
  email: string;
  dateOfBirth?: string;

  idType?: number;
  iqama?: string;
  iqamaExpiryDate?: string;
  eid?: string;
  eidExpiryDate?: string;
  passportNumber?: string;
  passportExpiryDate?: string;
  idTypeOtherName?: string;
  idTypeOtherNumber?: string;
  idTypeOtherExpiryDate?: string;
  visaNumber?: string;
  visaExpiryDate?: string;

  plateSource?: string;
  plateCode?: string;
  plateNumber?: string | null;
  plateLetter1?: string;
  plateLetter2?: string;
  plateLetter3?: string;

  location: string;
  building?: string;
  visitingDepartment?: string;
  gate?: string;
  meetingRoom?: string;
  visitReqType: string;
  visitPurpose?: string;
  visitPurposeOther?: string;
  hostEmail: string;
  hostMobileNumber: string;
  visitStartDate: string;
  visitEndDate: string;
  vehicleNo?: string;

  accessGroup?: string;

  note?: string;

  uploadPhoto?: any;
  uploadEid?: any;
  uploadPassport?: any;
  uploadIqama?: any;
  uploadIdOther?: any;
  uploadVisa?: any;
  uploadVehicleRegLicense?: any;
  uploadHostEmployeeCard?: any;

  resubmissionComment?: string;
}

export interface VIPData {
  name: string;
  companyName?: string;
  nationality?: string;
  number?: string;
  email: string;
  dateOfBirth?: string;

  idType?: number;
  iqama?: string;
  iqamaExpiryDate?: string;
  eid?: string;
  eidExpiryDate?: string;
  passportNumber?: string;
  passportExpiryDate?: string;
  idTypeOtherName?: string;
  idTypeOtherNumber?: string;
  idTypeOtherExpiryDate?: string;
  visaNumber?: string;
  visaExpiryDate?: string;

  plateSource?: string;
  plateCode?: string;
  plateNumber?: string | null;
  plateLetter1?: string;
  plateLetter2?: string;
  plateLetter3?: string;

  location: string;
  building?: string;
  visitingDepartment?: string;
  gate?: string;
  meetingRoom?: string;
  visitReqType: string;
  visitPurpose?: string;
  visitPurposeOther?: string;
  hostEmail: string;
  hostMobileNumber: string;
  visitStartDate: string;
  visitEndDate: string;
  vehicleNo?: string;

  note?: string;
  reqAccessLevels?: string;
  accessLevels?: string;

  uploadPhoto?: any;
  uploadEid?: any;
  uploadPassport?: any;
  uploadVehicleRegLicense?: any;
  uploadIqama?: any;
  uploadIdOther?: any;
  uploadVisa?: any;
  uploadHostEmployeeCard?: any;
}

export const SMSConfigCheckboxItems = [
  {
    id: 1,
    name: "VisitSubmitToVisitor",
    titleEn: "Enable Visit Submit To Visitor ",
    titleAr: "تفعيل إرسال الزيارة للزائر",
    checked: false,
  },
  {
    id: 2,
    name: "VisitApproval",
    titleEn: "Enable Visit Approval",
    titleAr: "تفعيل الموافقة على الزيارة",
    checked: false,
  },
  {
    id: 3,
    name: "VisitApprovedScheduledToVisitor",
    titleEn: "Enable Visit Approved Scheduled To Visitor",
    titleAr: "تفعيل إشعار الزيارة المجدولة المعتمدة للزائر",
    checked: false,
  },
  {
    id: 4,
    name: "VisitApprovedScheduledToHost",
    titleEn: "Enable Visit Approved Scheduled To Host",
    titleAr: "تفعيل إشعار الزيارة المجدولة المعتمدة للمضيف",
    checked: false,
  },
  {
    id: 5,
    name: "VisitRejectedToVisitor",
    titleEn: "Enable Visit Rejected To Visitor",
    titleAr: "تفعيل إشعار رفض الزيارة للزائر",
    checked: false,
  },
  {
    id: 6,
    name: "VisitRejectedToHost",
    titleEn: "Enable Visit Rejected To Host",
    titleAr: "تفعيل إشعار رفض الزيارة للمضيف",
    checked: false,
  },
  {
    id: 7,
    name: "ExternalCancelToVisitor",
    titleEn: "Enable External Cancel To Visitor",
    titleAr: "تفعيل إشعار الإلغاء الخارجي للزائر",
    checked: false,
  },
  {
    id: 8,
    name: "ExternalCancelToHost",
    titleEn: "Enable External Cancel To Host",
    titleAr: "تفعيل إشعار الإلغاء الخارجي للمضيف",
    checked: false,
  },
  {
    id: 9,
    name: "HostCancelToVisitor",
    titleEn: "Enable Host Cancel To Visitor",
    titleAr: "تفعيل إشعار إلغاء المضيف للزائر",
    checked: false,
  },
  {
    id: 10,
    name: "HostCancelToHost",
    titleEn: "Enable Host Cancel To Host",
    titleAr: "تفعيل إشعار إلغاء المضيف للمضيف",
    checked: false,
  },
  {
    id: 11,
    name: "DevicesRejectedToVisitor",
    titleEn: "Enable Devices Rejected To Visitor",
    titleAr: "تفعيل إشعار رفض الأجهزة للزائر",
    checked: false,
  },
  {
    id: 12,
    name: "DevicesRejectedToHost",
    titleEn: "Enable Devices Rejected To Host",
    titleAr: "تفعيل إشعار رفض الأجهزة للمضيف",
    checked: false,
  },
  {
    id: 13,
    name: "ExternalPasswordReset",
    titleEn: "Enable External Password Reset",
    titleAr: "تفعيل إعادة تعيين كلمة المرور الخارجية",
    checked: false,
  },
  {
    id: 14,
    name: "ExternalRegistration",
    titleEn: "Enable External Registration",
    titleAr: "تفعيل التسجيل الخارجي",
    checked: false,
  },
  {
    id: 15,
    name: "CheckIn",
    titleEn: "Enable Check In",
    titleAr: "تفعيل تسجيل الدخول",
    checked: false,
  },
  {
    id: 16,
    name: "CheckOut",
    titleEn: "Enable Check Out",
    titleAr: "تفعيل تسجيل الخروج",
    checked: false,
  },
  {
    id: 17,
    name: "OTP",
    titleEn: "Enable OTP",
    titleAr: "تفعيل كلمة المرور لمرة واحدة",
    checked: false,
  },
  {
    id: 18,
    name: "DirectStaffApprovalToSecurityUsers",
    titleEn: "Enable Direct Staff Approval To Security Users",
    titleAr: "تفعيل الموافقة المباشرة للموظفين لمستخدمي الأمن",
    checked: false,
  },
  {
    id: 19,
    name: "DirectStaffApprovalToSecurityManagers",
    titleEn: "Enable Direct Staff Approval To Security Managers",
    titleAr: "تفعيل الموافقة المباشرة للموظفين لمديري الأمن",
    checked: false,
  },
  {
    id: 20,
    name: "DirectStaffRejectionToSecurityUsers",
    titleEn: "Enable Direct Staff Rejection To Security Users",
    titleAr: "تفعيل رفض الموظفين المباشر لمستخدمي الأمن",
    checked: false,
  },
  {
    id: 21,
    name: "DirectStaffRejectionToSecurityManagers",
    titleEn: "Enable Direct Staff Rejection To Security Managers",
    titleAr: "تفعيل رفض الموظفين المباشر لمديري الأمن",
    checked: false,
  },
  {
    id: 22,
    name: "Evacuation",
    titleEn: "Enable Evacuation",
    titleAr: "تفعيل الإخلاء",
    checked: false,
  },
  // {
  //   id: 23,
  //   name: "PermitApproved",
  //   titleEn: "Enable Permit Approved",
  //   titleAr: "تفعيل الموافقة على التصريح",
  //   checked: false,
  // },
];

export const SMSTemplateFields = [
  {
    name: "VisitSubmitToVisitor",
    titleEn: "Visit Submit To Visitor SMS Template",
    titleAr: "إرسال الزيارة للزائر قالب رسالة نصية",
  },
  {
    name: "VisitApproval",
    titleEn: "Visit Approval SMS Template",
    titleAr: "الموافقة على الزيارة قالب رسالة نصية",
  },
  {
    name: "VisitApprovedScheduledToVisitor",
    titleEn: "Visit Approved Scheduled To Visitor SMS Template",
    titleAr: "إشعار الزيارة المجدولة المعتمدة للزائر قالب رسالة نصية",
  },
  {
    name: "VisitApprovedScheduledToHost",
    titleEn: "Visit Approved Scheduled To Host SMS Template",
    titleAr: "إشعار الزيارة المجدولة المعتمدة للمضيف قالب رسالة نصية",
  },
  {
    name: "VisitRejectedToVisitor",
    titleEn: "Visit Rejected To Visitor SMS Template",
    titleAr: "إشعار رفض الزيارة للزائر قالب رسالة نصية",
  },
  {
    name: "VisitRejectedToHost",
    titleEn: "Visit Rejected To Host SMS Template",
    titleAr: "إشعار رفض الزيارة للمضيف قالب رسالة نصية",
  },
  {
    name: "ExternalCancelToVisitor",
    titleEn: "External Cancel To Visitor SMS Template",
    titleAr: "إشعار الإلغاء الخارجي للزائر قالب رسالة نصية",
  },
  {
    name: "ExternalCancelToHost",
    titleEn: "External Cancel To Host SMS Template",
    titleAr: "إشعار الإلغاء الخارجي للمضيف قالب رسالة نصية",
  },
  {
    name: "HostCancelToVisitor",
    titleEn: "Host Cancel To Visitor SMS Template",
    titleAr: "إشعار إلغاء المضيف للزائر قالب رسالة نصية",
  },
  {
    name: "HostCancelToHost",
    titleEn: "Host Cancel To Host SMS Template",
    titleAr: "إشعار إلغاء المضيف للمضيف قالب رسالة نصية",
  },
  {
    name: "DevicesRejectedToVisitor",
    titleEn: "Request Information To Visitor SMS Template",
    titleAr: "إشعار معلومات الطلب للزائر قالب رسالة نصية",
  },
  {
    name: "DevicesRejectedToHost",
    titleEn: "Request Information To Host SMS Template",
    titleAr: "إشعار معلومات الطلب للمضيف قالب رسالة نصية",
  },
  {
    name: "ExternalPasswordReset",
    titleEn: "External Password Reset SMS Template",
    titleAr: "إعادة تعيين كلمة المرور الخارجية قالب رسالة نصية",
  },
  {
    name: "ExternalRegistration",
    titleEn: "External Registration SMS Template",
    titleAr: "التسجيل الخارجي قالب رسالة نصية",
  },
  {
    name: "CheckIn",
    titleEn: "Check In SMS Template",
    titleAr: "تسجيل الدخول قالب رسالة نصية",
  },
  {
    name: "CheckOut",
    titleEn: "Check Out SMS Template",
    titleAr: "تسجيل الخروج قالب رسالة نصية",
  },
  {
    name: "OTP",
    titleEn: "OTP SMS Template",
    titleAr: "كلمة المرور لمرة واحدة قالب رسالة نصية",
  },
  {
    name: "DirectStaffApprovalToSecurityUsers",
    titleEn: "Direct Staff Approval To Security Users SMS Template",
    titleAr: "الموافقة المباشرة للموظفين لمستخدمي الأمن قالب رسالة نصية",
  },
  {
    name: "DirectStaffApprovalToSecurityManagers",
    titleEn: "Direct Staff Approval To Security Managers SMS Template",
    titleAr: "الموافقة المباشرة للموظفين لمديري الأمن قالب رسالة نصية",
  },
  {
    name: "DirectStaffRejectionToSecurityUsers",
    titleEn: "Direct Staff Rejection To Security Users SMS Template",
    titleAr: "رفض الموظفين المباشر لمستخدمي الأمن قالب رسالة نصية",
  },
  {
    name: "DirectStaffRejectionToSecurityManagers",
    titleEn: "Direct Staff Rejection To Security Managers SMS Template",
    titleAr: "رفض الموظفين المباشر لمديري الأمن قالب رسالة نصية",
  },
  {
    name: "Evacuation",
    titleEn: "Evacuation SMS Template",
    titleAr: "الإخلاء قالب رسالة نصية",
  },
  // {
  //   name: "PermitApproved",
  //   titleEn: "Permit Approved SMS Template",
  //   titleAr: "الموافقة على التصريح قالب رسالة نصية",
  // },
] as const;

export const overStayedVisitors = [
  { Name: "John Doe", Stayed: "2 hours", Type: "Regular" },
  { Name: "Jane Smith", Stayed: "1.5 hours", Type: "Contractor" },
];

export const emailConfigFieldItems = [
  { id: 1, name: "AdminEmail" },
  { id: 2, name: "AdminPassword" },
  { id: 3, name: "Host" },
  { id: 4, name: "Port" },
];

export const emailConfigCheckboxItems = [
  {
    id: 5,
    name: "enableSsl",
    titleEn: "Enable SSL",
    titleAr: "تمكين SSL",
  },
  {
    id: 1,
    name: "enableCheckInEmail",
    titleEn: "Enable Check-in Email",
    titleAr: "تمكين البريد الإلكتروني لتسجيل الوصول",
  },
  {
    id: 2,
    name: "enableCheckOutEmail",
    titleEn: "Enable Check-out Email",
    titleAr: "تمكين البريد الإلكتروني للدفع",
  },
  {
    id: 3,
    name: "enableDevicesRejectedEmailToHost",
    titleEn: "Enable Devices Rejected Email To Host",
    titleAr: "تمكين الأجهزة التي تم رفض البريد الإلكتروني لها لاستضافة",
  },
  {
    id: 4,
    name: "enableDevicesRejectedEmailToVisitor",
    titleEn: "Enable Devices Rejected Email to Visitor",
    titleAr: "تمكين الأجهزة المرفوضة من إرسال البريد الإلكتروني للزائر",
  },
  {
    id: 6,
    name: "enableVisitRequestSubmitEmailToVisitor",
    titleEn: "Enable Visit Request Submitted Email To Visitor",
    titleAr: "تمكين إرسال طلب الزيارة عبر البريد الإلكتروني إلى الزائر",
  },
  {
    id: 7,
    name: "enableVisitApprovalEmail",
    titleEn: "Enable Visit Approved Email",
    titleAr: "تمكين البريد الإلكتروني المعتمد للزيارة",
  },
  {
    id: 8,
    name: "enableExternalCancelEmailToVisitor",
    titleEn: "Enable Visit Cancelled Email To Visitor",
    titleAr: "تمكين إرسال بريد إلكتروني للزائر بعد إلغاء الزيارة",
  },
  {
    id: 9,
    name: "enableExternalCancelEmailToHost",
    titleEn: "Enable Visit Cancelled Email To Host",
    titleAr: "تمكين زيارة البريد الإلكتروني الملغى للمضيف",
  },
  {
    id: 10,
    name: "enableVisitRejectedEmailToVisitor",
    titleEn: "Enable Visit Rejected Email To Visitor",
    titleAr: "تمكين إرسال بريد إلكتروني للزائر عند رفض الزيارة",
  },
  {
    id: 11,
    name: "enableVisitRejectedEmailToHost",
    titleEn: "Enable Visit Rejected Email To Host",
    titleAr: "تمكين زيارة البريد الإلكتروني المرفوض للمضيف",
  },
  {
    id: 12,
    name: "enableVisitApprovedScheduledEmailToVisitor",
    titleEn: "Enable Visit Approved Scheduled Email To Visitor",
    titleAr: "تمكين إرسال بريد إلكتروني مجدول للزيارة المعتمدة للزائر",
  },
  {
    id: 13,
    name: "enableVisitApprovedScheduledEmailToHost",
    titleEn: "Enable Visit Approved Scheduled Email To Host",
    titleAr: "تمكين زيارة البريد الإلكتروني المجدول المعتمد للمضيف",
  },
  {
    id: 14,
    name: "enableExternalRegistrationEmailToVisitor",
    titleEn: "Enable Account Registration Email To Visitor",
    titleAr: "تمكين تسجيل الحساب عبر البريد الإلكتروني للزائر",
  },
  {
    id: 15,
    name: "enableExternalPasswordResetEmailToVisitor",
    titleEn: "Enable Account Password Reset Email To Visitor",
    titleAr: "تمكين إعادة تعيين كلمة مرور الحساب عبر البريد الإلكتروني للزائر",
  },
  {
    id: 16,
    name: "enableOTPEmail",
    titleEn: "Enable Account Lockout OTP Email",
    titleAr: "تمكين قفل الحساب عبر البريد الإلكتروني OTP",
  },
  {
    id: 17,
    name: "enableDirectStaffApprovalEmailToSecurityUsers",
    titleEn: "Enable Direct Staff Approval Email To Security Users",
    titleAr:
      "تمكين إرسال موافقة الموظفين المباشرة عبر البريد الإلكتروني إلى مستخدمي الأمن",
  },
  {
    id: 18,
    name: "enableDirectStaffApprovalEmailToSecurityManagers",
    titleEn: "Enable Direct Staff Approval Email To Security Managers",
    titleAr:
      "تمكين إرسال الموافقة المباشرة للموظفين عبر البريد الإلكتروني إلى مديري الأمن",
  },
  {
    id: 19,
    name: "enableDirectStaffRejectionEmailToSecurityUsers",
    titleEn: "Enable Direct Staff Rejection Email To Security Users",
    titleAr: "تمكين إرسال بريد إلكتروني مباشر لرفض الموظفين إلى مستخدمي الأمان",
  },
  {
    id: 20,
    name: "enableDirectStaffRejectionEmailToSecurityManagers",
    titleEn: "Enable Direct Staff Rejection Email To Security Managers",
    titleAr: "تمكين إرسال بريد إلكتروني مباشر لرفض الموظفين إلى مديري الأمن",
  },
  // {
  //   id: 21,
  //   name: "enablePermitApprovedEmail",
  //   titleEn: "Enable Permit Approved Email",
  //   titleAr: "تمكين البريد الإلكتروني المعتمد للتصريح",
  // },
];

export const roles = [
  { roleNameEn: "Super Admin", roleNameAr: "مدير البرنامج" },
  { roleNameEn: "Staff", roleNameAr: "الموظف" },
  { roleNameEn: "Reception", roleNameAr: "موظف الإستقبال" },
  { roleNameEn: "Security User", roleNameAr: "مستخدم الأمان" },
  { roleNameEn: "User Management", roleNameAr: "إدارةالمستخدم" },
];

export const passwordRequirements = [
  "Minimum 8 characters",
  "At least 1 uppercase character",
  "At least 1 lowercase character",
  "At least 1 number",
  "At least 1 special character",
];

export const healthDeclarations = [
  {
    heading: "A- Medical Condition",
    items: [
      "Ensure you are feeling well and healthy to proceed with your visit",
      "As a precaution, pregnant women should avoid exposure to the high magnetic field areas",
      "Avoid wearing contact lenses in the molten metal areas",
      "Do not enter the plant if you have a pacemaker or cochlear implant",
      "Ensure you are not under the influence of drugs and alcohol",
    ],
  },
  {
    heading: "B- Prohibited and Banned Items",
    items: [
      "Certain items butane lighters, water bottles, pressurized cans etc., are prohibited in molten metal areas",
      "Credit cards and analogue watches may be damaged by the magnetic field",
      "You are not allowed to bring prohibited items like, firearms, ammunition, alcohol, or drugs on site",
    ],
  },
  {
    heading: "C- General Safety Rules",
    items: [
      "Always remain with your host",
      "Smoking is allowed only in dedicated smoking areas",
      "In the unfortunate event of an incident or injury it has to be reported to your MOFA host",
      "If an emergency / fire alarm is activated during your visit, remain with your host and proceed to the nearest assembly point",
      "Visitors are not allowed to drive in Operational Areas",
      "When visiting and driving in Corporate areas, always adhere to traffic signs and speed limits",
      "Certain areas in Operations might require the visitor to wear PPE. Kindly clarify with your host prior to entering the site",
      "Always use pedestrian walkways and road crossings within the plant",
      "No photography is allowed within MOFA boundaries",
    ],
  },
];

export const utilitiesConfigProcessOptions = [
  { labelEn: "Encrypt", labelAr: "Encrypt", value: PROCESSES.ENCRYPT },
  { labelEn: "Decrypt", labelAr: "Decrypt", value: PROCESSES.DECRYPT },
];

export const pingOptions = [
  { labelEn: "CMD", labelAr: "CMD", value: EPingType.CMD },
  {
    labelEn: "FR Challenge",
    labelAr: "FR Challenge",
    value: EPingType.FRChallenge,
  },
];

export const musterPointsOptions = [
  { id: 1, label: "Muster A (North Parking)" },
  { id: 2, label: "Muster B (Back Gate)" },
];

export const evacuationWhoToIncludeOptions = [
  { id: 3, label: "Employees" },
  { id: 4, label: "Visitors" },
  { id: 5, label: "Contractors" },
];

export const permitToWorkUndertakings = [
  "undertakingSafetyCompliance",
  "undertakingWorkingHoursCompliance",
  "undertakingRestoreSite",
  "undertakingPresentPermit",
];

export const entryStickerForParkingAcknowledgements = [
  'employeePermittedParking',
  'parkingProhibitedNonDesignated',
  'parkingProhibitedForbiddenAreas',
  'useAuthorizedVehicleOnly',
  'doNotLendStickerOrVehicle',
  // 'attachDocumentsForRequest',
  // 'sendFormViaSahil',
  // 'employeeContactAfterSticker',
  // 'contactExtensionForInquiry',
  // 'lostStickerProcedure',
]

export const requestedServicesOptions = [
  {
    "n_Id": 1,
    "s_Name_En": "Issuance",
    "s_Name_Ar": "إصدار"
  },
  {
    "n_Id": 2,
    "s_Name_En": "Addition",
    "s_Name_Ar": "إضافة"
  },
  {
    "n_Id": 3,
    "s_Name_En": "Cancellation",
    "s_Name_Ar": "إلغاء"
  }
];

// export const officeAccessAuthorizationPermitDetails = {
//   "n_OfficeAccessAuthorisationRequestID": 14,
//   "s_RequestCode": "OAA-14",
//   "s_EmployeeName": "محمد بدر أسامة رياض لتقنية المعلومات",
//   "s_EmployeeNumber": "E096",
//   "s_MobileNumber": "0527897878",
//   "s_Department": "IT Section",
//   "s_OfficeNumber": "PO-3209",
//   "dt_RequestDate": "2026-04-01T13:05:28.973",
//   "n_ApprovalStatus": 49,
//   "s_ApprovalStatus_En": "Approved",
//   "s_ApprovalStatus_Ar": "صدرت الموافقة",
//   "n_CurrentApproverOrderNo": null,
//   "n_PermitNextApproverRoleID": null,
//   "requestedServices": [
//     {
//       "n_RequestedServiceID": 2405,
//       "n_ServiceID": 0,
//       "s_ServiceName_En": null,
//       "s_ServiceName_Ar": null
//     },
//     {
//       "n_RequestedServiceID": 2406,
//       "n_ServiceID": 0,
//       "s_ServiceName_En": null,
//       "s_ServiceName_Ar": null
//     }
//   ],
//   "approvers": [
//     {
//       "approverRole": "Direct Manager",
//       "approverName": "",
//       "dt_ApprovalDate": "2026-04-01T13:06:29.83",
//       "comments": null,
//       "uploadSignature": null,
//       "uploadSignatureContentType": null
//     },
//     {
//       "approverRole": "Cyber Security",
//       "approverName": "",
//       "dt_ApprovalDate": "2026-04-01T13:14:50.377",
//       "comments": null,
//       "uploadSignature": null,
//       "uploadSignatureContentType": null
//     },
//     {
//       "approverRole": "Security User",
//       "approverName": "",
//       "dt_ApprovalDate": "2026-04-01T13:15:34.65",
//       "comments": null,
//       "uploadSignature": null,
//       "uploadSignatureContentType": null
//     },
//     {
//       "approverRole": "Security Manager",
//       "approverName": "",
//       "dt_ApprovalDate": "2026-04-01T13:16:26.623",
//       "comments": null,
//       "uploadSignature": null,
//       "uploadSignatureContentType": null
//     }
//   ]
// }

export const pcInOutPermitDetails = {
  employeeName: "محمد بدر أسامة رياض لتقنية المعلومات",
  "s_Building": "b1",
  "s_LaptopType": "laptop",
  "s_LaptopSerialNumber": "123",
  "dt_PermitStartDate": "1/5/2026 4:53:00 PM",
  "dt_PermitEndDate": "1/5/2026 5:53:00 PM",
  "haveUserCardFile": 1,
  "workPermitApprovers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "base64string",
      uploadSignatureContentType: "image/png",
    }
  ]
}

export const lostVehicleStickerIdCardPermitDetails = {
  "s_StickerNumber": "90",
  "s_CopyNumber": "89",
  "workPermitApprovers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "base64string",
      uploadSignatureContentType: "image/png",
    }
  ]
}

export const issuanceRenealIdPermitDetails = {
  "s_ContractorEmployeeName": "ali",
  "s_Nationality": "AFG",
  "s_NationalID": "4839248",
  "dt_NationalIDExpiryDate": "2026-04-05T00:00:00",
  "dt_DateOfBirth": "2026-02-24T00:00:00",
  "s_ContractorCompanyName": "tektron",
  "s_Department": "IT",
  "s_JobPosition": "head",
  "dt_WorkStartDate": "2026-03-12T00:00:00",
  "s_ResidentialAddress": "Plot R 508",
  "s_ContactNumber": "4893248392",
  "dt_CardValidityFrom": "2026-03-03T00:00:00",
  "dt_CardValidityUntil": "2026-04-05T00:00:00",
  "havePersonalPhotographFile": true,
  "haveNationalIDCopyFile": true,
  "haveAuthorizationLetterFile": true,
  "workPermitApprovers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "base64string",
      uploadSignatureContentType: "image/png",
    }
  ]
}

export const parkingStickerRequestPermitDetails = {
  "s_Name": "محمد بدر أسامة رياض لتقنية المعلومات",
  "s_Department": "IT Section",
  "s_JobTitle": "Staff",
  "s_MobileNo": "0527897878",
  "s_OfficePhone": "483294823",
  "s_EmployeeNumber": "E096",
  "n_ApprovalStatus": 50,
  "s_ApprovalStatus_En": "Pending",
  "s_ApprovalStatus_Ar": "قيد الانتظار",
  "n_CurrentApproverOrderNo": 1,
  "n_PermitNextApproverRoleID": 15,
  "vehicleAccess": [
    {
      "n_VehicleAccessID": 1,
      "s_VehicleAccess_En": "Designated",
      "s_VehicleAccess_Ar": "مخصص"
    }
  ],
  haveHostEmployeeCard: true,
  haveHostNationalID: true,
  "buildings": [
    {
      s_LocationName_En: 'Riyadh',
      s_LocationName_Ar: 'الرياض',
      items: [
        {
          "s_BuildingName_En": "Quota-B1",
          "s_BuildingName_Ar": "الحصة - B1"
        },
        {
          "s_BuildingName_En": "Warehouse",
          "s_BuildingName_Ar": "مبنى المستودعات"
        }
      ]
    },
    {
      s_LocationName_En: 'Madinah',
      s_LocationName_Ar: 'المدينة',
      items: [
        {
          "s_BuildingName_En": "Quota-B2",
          "s_BuildingName_Ar": "الحصة - B2"
        },

      ]
    },
  ],
  "vehicles": [
    {
      "n_ParkingStickerVehicleID": 78,
      "n_PlateSource": 2205,
      "n_PlateLetter1": 2211,
      "n_PlateLetter2": 2215,
      "n_PlateLetter3": 2211,
      "s_PlateNumber": "4324",
      "s_ModelNumber": "civic",
      "s_Color": "red",
      "s_StickerNumber": "4932849",
      "s_CopyNumber": "98343",
      "haveVehicleRegistrationFile": true,
    },
    {
      "n_ParkingStickerVehicleID": 79,
      "n_PlateSource": 2206,
      "n_PlateLetter1": 2212,
      "n_PlateLetter2": 2212,
      "n_PlateLetter3": 2216,
      "s_PlateNumber": "4234",
      "s_ModelNumber": "city",
      "s_Color": "yellow",
      "s_StickerNumber": "98433",
      "s_CopyNumber": "86843728",
      "haveVehicleRegistrationFile": true,
    }
  ],
  "approvers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "",
      uploadSignatureContentType: "image/png",
    }
  ]
}

export const warehouseInOutPermitDetails = {
  "s_ExitBuilding": "b1",
  "s_EntryBuilding": "b2",
  "s_EscortingEmployeeName": "ali",
  "s_PermitDescription_En": "Furniture",
  "s_PermitDescriptionOthersValue": "",
  "dt_PermitStartDate": "1/5/2026 4:53:41 PM",
  "dt_PermitEndDate": "1/5/2026 5:53:41 PM",
  "haveUserCardFile": true,
  "permitItems": [
    {
      "n_PermitItemID": 44,
      "s_ItemType": "carpet",
      "n_Quantity": 12,
      "s_SupplyingOrExportingEntity": "MOFA"
    }
  ],
  permitPersonnel: [
    {
      "n_PermitPersonnelID": 30,
      "n_PermitWarehouseID": 17,
      "s_TempClientID": null,
      "s_PersonnelName": "ayat",
      "nationality": "AFG",
      "s_Iqama": "437266",
      "dt_IqamaIssue": "2025-12-29T00:00:00",
      "s_IssuingAuthority": "Riyadh",
      "n_IsPersonnelDriver": 1,
      "haveIqamaUpload": true,
      "haveVehicleRegistrationFile": true
    }
  ],
  "permitVehicles": [
    {
      "n_PermitVehicleID": 21,
      "n_PermitWarehouseID": 17,
      "n_DriverPersonnelID": 30,
      "s_PlateSource_En": 'Equipment',
      "s_PlateNumber": "12332",
      "s_ModelNumber": '4233',
      "s_Color": "Red",
      "s_PlateLetter1_En": 'A',
      "s_PlateLetter2_En": 'B',
      "s_PlateLetter3_En": 'C'
    }
  ],
  "approvers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "",
      uploadSignatureContentType: "image/png",
    }
  ]
}

export const permitToWorkPermitDetails = {
  "s_AffectedService_En": 'Communication',
  "s_FloorNo": "4",
  "s_OfficeNo": "FO-39",
  "dt_PermitStartDate": "2026-03-30T18:48:58",
  "dt_PermitEndDate": "2026-03-30T19:48:58",
  n_WorkCategoryCode: 2341,
  "s_WorkCategory_En": 'High Risk Works',
  "s_WorkType_En": 'MEP',
  "s_HighRiskWorkCategory_En": 'Working At Height',

  "buildings": [
    {
      s_LocationName_En: 'Riyadh',
      s_LocationName_Ar: 'الرياض',
      items: [
        {
          "s_BuildingName_En": "Quota-B1",
          "s_BuildingName_Ar": "الحصة - B1"
        },
        {
          "s_BuildingName_En": "Warehouse",
          "s_BuildingName_Ar": "مبنى المستودعات"
        }
      ]
    },
    {
      s_LocationName_En: 'Madinah',
      s_LocationName_Ar: 'المدينة',
      items: [
        {
          "s_BuildingName_En": "Quota-B2",
          "s_BuildingName_Ar": "الحصة - B2"
        },

      ]
    },
  ],

  "s_ScopeOfWork": "Detailed Scope of Work *Detailed Scope of Work *Detailed Scope of Work *Detailed Scope of Work *Detailed Scope of Work *",

  "haveWorkPlanFile": true,
  "haveMethodStatementFile": true,
  "haveRiskAssessmentFile": true,

  "safetyChecklist": [
    {
      "id": "4",
      "titleEn": "Safety Measures",
      "titleAr": "إجراءات السلامة",
      "items": [
        {
          "id": "16",
          "titleEn": "Persons engaged are qualified, trained and competent",
          "titleAr": "الأشخاص المشاركون مؤهلون ومدربون وذوو كفاءة",
          checked: true
        },
        {
          "id": "17",
          "titleEn": "Risk assessment available and explained to crew",
          "titleAr": "تقييم المخاطر متوفر وتم شرحه لطاقم العمل",
          checked: true
        },
        {
          "id": "18",
          "titleEn": "All control measures implemented",
          "titleAr": "تم تنفيذ جميع إجراءات التحكم",
          checked: true
        },
        {
          "id": "19",
          "titleEn": "Supervision available full time",
          "titleAr": "الإشراف متوفر بدوام كامل",
          checked: false
        },
        {
          "id": "20",
          "titleEn": "Workplace clean and free from flammable materials",
          "titleAr": "مكان العمل نظيف وخالٍ من المواد القابلة للاشتعال",
          checked: false
        },
        {
          "id": "21",
          "titleEn": "Proper working platform and access provided",
          "titleAr": "تم توفير منصة عمل مناسبة ووسائل وصول آمنة",
          checked: false
        },
        {
          "id": "22",
          "titleEn": "Required PPE provided as per risk assessment",
          "titleAr": "تم توفير معدات الوقاية الشخصية المطلوبة حسب تقييم المخاطر",
          checked: false
        }
      ]
    },
    {
      "id": "5",
      "titleEn": "Worksite Safety Controls",
      "titleAr": "ضوابط سلامة موقع العمل",
      "items": [
        {
          "id": "23",
          "titleEn": "Adequate ventilation and lighting provided",
          "titleAr": "تم توفير تهوية وإضاءة كافيتين",
          checked: false
        },
        {
          "id": "24",
          "titleEn": "Warning signs and barricades installed",
          "titleAr": "تم تركيب لوحات التحذير والحواجز",
          checked: false
        },
        {
          "id": "25",
          "titleEn": "Area enclosed to prevent flying objects / sparks",
          "titleAr": "تم إحاطة المنطقة لمنع تطاير الأجسام/الشرر",
          checked: true
        },
        {
          "id": "26",
          "titleEn": "Electrical / equipment isolation",
          "titleAr": "عزل الكهرباء/المعدات",
          checked: false
        },
        {
          "id": "27",
          "titleEn": "Gas test conducted",
          "titleAr": "تم إجراء اختبار الغاز",
          checked: false
        },
        {
          "id": "28",
          "titleEn": "Fire watcher assigned and 1-hour post-work watch",
          "titleAr": "تم تعيين مراقب حريق ومراقبة لمدة ساعة بعد انتهاء العمل",
          checked: false
        },
        {
          "id": "29",
          "titleEn": "Location plan / layout attached",
          "titleAr": "تم إرفاق مخطط/تخطيط الموقع",
          checked: false
        }
      ]
    },
    {
      "id": "6",
      "titleEn": "Equipment to be Used",
      "titleAr": "المعدات المستخدمة",
      "items": [
        {
          "id": "30",
          "titleEn": "Fire extinguisher available",
          "titleAr": "طفاية حريق متوفرة",
          checked: false
        },
        {
          "id": "31",
          "titleEn": "Hoses / torches in safe condition",
          "titleAr": "الخراطيم/المشاعل بحالة آمنة",
          checked: false
        },
        {
          "id": "32",
          "titleEn": "Cylinders placed on trolley and secured",
          "titleAr": "تم وضع الأسطوانات على عربة وتثبيتها",
          checked: false
        },
        {
          "id": "33",
          "titleEn": "Equipment / tools in safe condition",
          "titleAr": "المعدات/الأدوات بحالة آمنة",
          checked: false
        },
        {
          "id": "34",
          "titleEn": "Respirator available",
          "titleAr": "جهاز تنفس متوفر",
          checked: false
        },
        {
          "id": "35",
          "titleEn": "Torch regulators and gauges in good condition",
          "titleAr": "منظمات وعدادات المشعل بحالة جيدة",
          checked: false
        },
        {
          "id": "36",
          "titleEn": "Flashback arrestors provided",
          "titleAr": "تم توفير مانعات رجوع اللهب",
          checked: true
        }
      ]
    }
  ],

  "approvers": [
    {
      approverRole: "Manager",
      approverName: "أحمد محمد",
      dt_ApprovalDate: "2026-03-30T19:00:36.307",
      comments: null,
      uploadSignature: "",
      uploadSignatureContentType: "image/png",
    }
  ]
}